import {
    Button,
    Dropdown,
    Flex,
    Space,
    Table,
} from "antd";
import { useTranslation } from "react-i18next";
import { MoreOutlined, PlusOutlined, FilterOutlined } from "@ant-design/icons";
import { MainLayout } from "components/layouts";
import TableAntdFix from "components/elements/Table/TableFixPage";
import { FUND_STATUS, FUND_TYPE } from "../schemas/FundSchemas";
import dayjs from "dayjs";

const FundList = ({
    isLoading,
    fundList,
    pagination,
    onEdit,
    onView,
    onDelete,
    onCreate,
    onChange,
}) => {
    const { i18n, t } = useTranslation();

    const columns = [
        {
            title: t("fund.label.fundType"),
            dataIndex: "fundType",
            key: "fundType",
            render: (_, record) => {
                let type = FUND_TYPE.find(o => o.value == _);
                return i18n?.language === "th" ? type.name : type.nameEn
            }
        },
        {
            title: t("fund.label.fundName"),
            dataIndex: "fundNameTh",
            key: "fundNameTh",
            render: (_, record) => {
                return i18n?.language === "th" ? record.fundNameTh : record.fundNameEn
            }
        },
        {
            title: t("fund.label.fundStartDate"),
            dataIndex: "fundStartDate",
            key: "fundStartDate",
            render: (_) => {
                return dayjs(_).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")
            }
        },
        {
            title: t("fund.label.createDate"),
            dataIndex: "createdDate",
            key: "createdDate",
            render: (_) => {
                return dayjs(_).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")
            }
        },
        {
            title: t("fund.label.status"),
            dataIndex: "statusFlag",
            key: "statusFlag",
            render: (_) => {
                let type = FUND_STATUS?.find(o => o.value == _);
                return i18n?.language === "th" ? type?.name : type?.nameEn
            }
        },
        {
            title: "",
            key: "action",
            width: 60,
            fixed: "right",
            align: "center",
            render: (_, record) => (
                <Dropdown
                    menu={{
                        items: [
                            {
                                key: "view",
                                label: t("common.view"),
                                onClick: () => onView(record),
                            },
                            {
                                key: "edit",
                                label: t("common.edit"),
                                onClick: () => onEdit(record),
                            },
                            {
                                type: "divider",
                            },
                            {
                                key: "delete",
                                danger: true,
                                label: t("common.delete"),
                                onClick: () => onDelete(record),
                            },
                        ],
                    }}
                    trigger={["click"]}
                >
                    <Button
                        type="text"
                        icon={<MoreOutlined />}
                    />
                </Dropdown>
            ),
        },
    ];

    return (
        <Space
            direction="vertical"
            size={24}
            style={{ width: "100%" }}
        >
            <Flex justify="space-between" align="center">
                <Flex vertical>
                    <h2>
                        {t("fund.header")}
                    </h2>
                </Flex>

                <Flex gap={10}>
                    <Button
                        icon={<FilterOutlined />}
                    >
                        {t("common.filter")}
                    </Button>

                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={onCreate}
                    >
                        {t("fund.label.addFund")}
                    </Button>
                </Flex>
            </Flex>


            <TableAntdFix
                loading={isLoading}
                pagination={{
                    ...pagination,
                }}
                dataSource={fundList}
                columns={columns}
                onChange={onChange}
                // scroll={{ x: 'scroll' }}
                scroll={{ x: '1000px' }}
                tableLayout="fixed"
            />
        </Space>
    );
};

export default FundList;